/**
 * Carrier reference data (T12, frontend-only). Single source for the Sales
 * package selects and the tracking link-out label, mirroring the backend
 * `Carrier` enum. Pages import these instead of inlining carrier arrays.
 *
 * `CARRIERS` entries are `[key, label]` (the select option order, matching the
 * backend choices). `CARRIER_LABEL` maps a carrier key to its display name for
 * the tracking-url link-out (#300).
 */

/** Ordered carrier options for the package selects. */
const CARRIERS = [
  ['usps', 'USPS'],
  ['ups', 'UPS'],
  ['fedex', 'FedEx'],
  ['dhl', 'DHL'],
  ['other', 'Other'],
];

/** Carrier key → display name (tracking link-out label). */
const CARRIER_LABEL = Object.fromEntries(CARRIERS.map(([key, label]) => [key, label]));

export {
  CARRIER_LABEL,
  CARRIERS,
};
